import Vue from "vue";
import PortalVue from "portal-vue";
import VueHead from "vue-head";
import App from "./App.vue";
import router from "./router";

Vue.config.productionTip = false;

Vue.use(PortalVue);
Vue.use(VueHead);

new Vue({
    render: h => h(App),
    router
}).$mount("#app");
